var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 30,
    viewBox: "0 0 32 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0L0 6.58405V10.6616L3.29959 9.34239L16 4.11953L28.7004 9.34239L32 10.6616V6.58405L16 0Z",
    fill: "#EF916C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7969 17.1078C13.7969 17.9833 14.4928 18.469 15.3867 18.6788L15.5127 18.7088V15.6387C14.6548 15.6687 13.7969 16.1244 13.7969 17.1078Z",
    fill: "#F75B11"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4375 20.9453V24.3573C17.4574 24.3573 18.3813 23.7936 18.3813 22.6423C18.3813 21.6889 17.6493 21.2691 16.4375 20.9453Z",
    fill: "#F75B11"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9973 7.70557L3.29688 12.9284V29.9822H28.6977V12.9284L15.9973 7.70557ZM16.4352 26.0605V27.4157H15.5113V26.0426C13.1476 25.8507 11.4978 24.2436 11.5278 21.965H13.7176C13.7176 23.4701 14.5395 24.2137 15.5173 24.3636V20.7178L14.9174 20.5738C13.3096 20.2021 11.7258 19.2966 11.7258 17.2219C11.7258 15.0392 13.6696 14.0498 15.5293 13.9358V12.7365H16.4352V13.9358C18.7809 14.1457 20.3047 15.6988 20.3047 17.8335H18.133C18.179 17.3224 18.0294 16.813 17.7143 16.4079C17.3992 16.0028 16.9421 15.7322 16.4352 15.6508V18.9008L16.5672 18.9368C18.313 19.3566 20.4667 20.1361 20.4667 22.4807C20.4667 24.7473 18.559 25.9466 16.4352 26.0605Z",
    fill: "#F75B11"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.e4720b7a7ae2a84e63c343961cedda8b.svg";
export { ForwardRef as ReactComponent };